import Base from './base'

class UiState extends Base {

    defaults() {
        return {
            language: document.documentElement.lang
        };
    }

}

export default UiState;